// import React, { useEffect, useState, useRef } from 'react';
// import { makeStyles } from '@material-ui/core/styles';
// import AppBar from '@material-ui/core/AppBar';
// import Toolbar from '@material-ui/core/Toolbar';
// import IconButton from '@material-ui/core/IconButton';
// import MenuItem from '@material-ui/core/MenuItem';
// import Menu from '@material-ui/core/Menu';
// import Badge from '@material-ui/core/Badge';
// import NotificationsIcon from '@material-ui/icons/Notifications';
// import SettingsIcon from '@material-ui/icons/Settings';
// import ScheduleOutlinedIcon from '@material-ui/icons/ScheduleOutlined';
// import AddShoppingCartOutlinedIcon from '@material-ui/icons/AddShoppingCartOutlined';
// import PersonOutlineOutlined from '@material-ui/icons/PersonOutlineOutlined';
// import SettingsOutlined from '@material-ui/icons/SettingsOutlined';
// import PowerSettingsNewOutlined from '@material-ui/icons/PowerSettingsNewOutlined';
// import { Link } from "react-router-dom";
// import axios from "axios";
// import config from "../Helpers/config.json";
// import { connect } from 'react-redux';
// import { bindActionCreators } from "redux";
// import * as snackbarActions from "../Redux/Actions/SnackbarActions/SnackbarActions";
// import { BootstrapTooltip } from "../Utils/BootstrapTooltip";
// import { Modal, Paper, Typography, Tabs, Tab, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Button } from "@material-ui/core";

// // 🔹 Error Boundary
// class ErrorBoundary extends React.Component {
//     constructor(props) { super(props); this.state = { hasError: false }; }
//     static getDerivedStateFromError() { return { hasError: true }; }
//     componentDidCatch(error, errorInfo) { console.error("Error in AppHeader:", error, errorInfo); }
//     render() {
//         if (this.state.hasError) {
//             return (
//                 <AppBar style={{ backgroundColor: '#b71c1c' }}>
//                     <Toolbar variant="dense">
//                         <span style={{ color: "#fff" }}>Something went wrong loading the header.</span>
//                     </Toolbar>
//                 </AppBar>
//             );
//         }
//         return this.props.children;
//     }
// }

// // 🔹 Styles
// const useStyles = makeStyles((theme) => ({
//     grow: { flexGrow: 1 },
//     sectionDesktop: { display: 'flex', alignItems: 'center', gap: theme.spacing(1) },
//     menuItem: { minHeight: 40 },
//     modalWrapper: {
//         position: "fixed",
//         top: "50%",
//         left: "50%",
//         transform: "translate(-50%, -50%)",
//         padding: theme.spacing(2),
//         maxWidth: 1000,
//         width: "90%",
//         zIndex: 1500,
//         maxHeight: "80vh",
//         overflowY: "auto",
//     },
//     overlay: {
//         position: "fixed",
//         top: 0,
//         left: 0,
//         width: "100%",
//         height: "100%",
//         backgroundColor: "rgba(0,0,0,0.3)",
//         zIndex: 1400,
//     },
//     tableHead: { fontWeight: 'bold', fontSize: '0.85rem' },
//     tabPanel: { paddingTop: theme.spacing(1) },
//     anniversaryAppBar: {
//         background: 'linear-gradient(270deg, #ff4081, #ffeb3b, #1fa7b0)',
//         backgroundSize: '600% 600%',
//         animation: '$gradientAnimation 20s ease infinite',
//     },
//     '@keyframes gradientAnimation': {
//         '0%': { backgroundPosition: '0% 50%' },
//         '50%': { backgroundPosition: '100% 50%' },
//         '100%': { backgroundPosition: '0% 50%' },
//     },
//     '@keyframes glow': {
//         from: { textShadow: '0 0 8px #ff4081' },
//         to: { textShadow: '0 0 16px #ffeb3b, 0 0 24px #1fa7b0' },
//     },
//     anniversaryText: {
//         color: '#fff',
//         fontWeight: 'bold',
//         fontSize: '0.95rem',
//         textAlign: 'center',
//         width: '100%',
//         flexGrow: 1,
//         animation: '$glow 2s ease-in-out infinite alternate',
//         textShadow: '0 0 8px #ff4081, 0 0 16px #ffeb3b, 0 0 24px #1fa7b0',
//         padding: '4px 0',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//     },
// }));

// function AppHeader({ actions, children, ...props }) {
//     const classes = useStyles();
//     const [showBanner, setShowBanner] = useState(true);

//     const [anchorEl, setAnchorEl] = useState(null);
//     const [expired, setExpired] = useState(null);
//     const [expiredItems, setExpiredItems] = useState(0);
//     const [outOfStock, setOutOfStock] = useState(0);
//     const [approvalCount, setApprovalCount] = useState(0);
//     const [pendingCount, setPendingCount] = useState(0);
//     const [approvedCount, setApprovedCount] = useState(0);

//     const [popupVisible, setPopupVisible] = useState(false);
//     const [tabIndex, setTabIndex] = useState(0);
//     const [expiredList, setExpiredList] = useState([]);
//     const [outOfStockList, setOutOfStockList] = useState([]);

//     const prevCounts = useRef({ approval: 0, pending: 0, approved: 0 });
//     const alertAudio = useRef(null);
//     const approvedSaleAudio = useRef(null);

//     const user = JSON.parse(sessionStorage.getItem("user")) || {};
//     const permissions = user?.permission || {};
//     const user_name = user?.user_name || "";
//     const approval_status = permissions.approval_status || {};
//     const managependingsale = permissions.managependingsale || {};

//     const POLL_INTERVAL = 9000; 
//     const SESSION_KEY = "popupShown";

//     const playAlert = () => {
//         if (!alertAudio.current) alertAudio.current = new Audio('/audio/happy-bells-notification.mp3');
//         alertAudio.current.play().catch(e => console.warn("Audio blocked:", e.message));
//     };
//     const playAlertApprovedSale = () => {
//         if (!approvedSaleAudio.current) approvedSaleAudio.current = new Audio('/audio/great-success.mp3');
//         approvedSaleAudio.current.play().catch(e => console.warn("Audio blocked:", e.message));
//     };

//     useEffect(() => {
//         import('canvas-confetti').then((confetti) => {
//           confetti.default({ particleCount: 200, spread: 80, origin: { y: 0.6 } });
//         });
//     }, []);

//     useEffect(() => {
//         let isMounted = true;
//         const controller = new AbortController();

//         const fetchStaticCounts = async () => {
//             try {
//                 const [expiredRes, stockRes] = await Promise.all([
//                     axios.get(`${config.epharmUrl}/User/expired_products`, { signal: controller.signal }),
//                     axios.get(`${config.epharmUrl}/User/out_of_stock`, { signal: controller.signal })
//                 ]);
//                 if (!isMounted) return;

//                 const expiredCount = expiredRes.data?.expired_products?.length || 0;
//                 const stockCount = stockRes.data?.length || 0;

//                 setExpiredItems(expiredCount);
//                 setOutOfStock(stockCount);
//                 setExpiredList(expiredRes.data?.expired_products || []);
//                 setOutOfStockList(stockRes.data || []);

//                 if (!sessionStorage.getItem(SESSION_KEY) && (expiredCount > 0 || stockCount > 0)) {
//                     setPopupVisible(true);
//                     sessionStorage.setItem(SESSION_KEY, "true");
//                 }
//             } catch (err) {
//                 if (err.name !== "CanceledError") console.error("Error fetching static counts:", err.message || err);
//             }
//         };

//         const fetchDynamicCounts = async () => {
//             try {
//                 if (!isMounted) return;
//                 if (approval_status.create) {
//                     const res = await axios.get(`${config.epharmUrl}/Cinvoice/count/pending_sales`, { signal: controller.signal });
//                     const count = res.data?.count || 0;
//                     setApprovalCount(count);
//                     if (count > prevCounts.current.approval) playAlert();
//                     prevCounts.current.approval = count;
//                 }
//                 if (managependingsale.create) {
//                     const res = await axios.get(`${config.epharmUrl}/Cinvoice/count/pending_sales`, { signal: controller.signal });
//                     const count = res.data?.count || 0;
//                     setPendingCount(count);
//                     if (count > prevCounts.current.pending) playAlert();
//                     prevCounts.current.pending = count;
//                 }
//                 if (approval_status.read) {
//                     const approvedRes = await axios.get(`${config.epharmUrl}/Cinvoice/count/approved_sales`, { signal: controller.signal });
//                     const count = approvedRes.data?.count || 0;
//                     setApprovedCount(count);
//                     if (count > prevCounts.current.approved) playAlertApprovedSale();
//                     prevCounts.current.approved = count;
//                 }
//             } catch (err) {
//                 if (err.name !== "CanceledError") console.error("Error fetching dynamic counts:", err.message || err);
//             }
//         };

//         fetchStaticCounts();
//         fetchDynamicCounts();
//         const interval = setInterval(fetchDynamicCounts, POLL_INTERVAL);

//         return () => { isMounted = false; controller.abort(); clearInterval(interval); };
//     }, [approval_status.read, managependingsale.read]);

//     const handleProfileMenuOpen = e => setAnchorEl(e.currentTarget);
//     const handleMenuClose = () => setAnchorEl(null);
//     const handleExpiredMenuOpen = e => setExpired(e.currentTarget);
//     const handleExpiredMenuClose = () => setExpired(null);

//     return (
//         <ErrorBoundary>
//             <AppBar color="primary" style={{ backgroundColor: '#1fa7b0' }} {...props}>
//                 <Toolbar variant="dense" style={{ minHeight: 48 }}>
//                     <div>{children}</div>
//                     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
//                         {showBanner && (
//                             <Typography variant="subtitle1" className={classes.anniversaryText}>
                            
//                             </Typography>
//                         )}
//                     </div>
//                     <div className={classes.grow} />
//                     <div className={classes.sectionDesktop}>
//                         <BootstrapTooltip title='Notifications'>
//                             <IconButton aria-controls="expired-menu" onClick={handleExpiredMenuOpen} color="inherit" size="small">
//                                 <Badge badgeContent={expiredItems + outOfStock + approvalCount + pendingCount + approvedCount} color="secondary">
//                                     <NotificationsIcon fontSize="small"/>
//                                 </Badge>
//                             </IconButton>
//                         </BootstrapTooltip>
//                         <IconButton edge="end" aria-controls="profile-menu" onClick={handleProfileMenuOpen} color="inherit" size="small">
//                             <SettingsIcon fontSize="small"/>
//                         </IconButton>
//                         <IconButton edge="end" aria-controls="profile-menu" aria-haspopup="true" onClick={handleProfileMenuOpen} color="inherit" size="small" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
//                             <PersonOutlineOutlined fontSize="small"/>
//                             <Typography variant="body2" noWrap>{user_name}</Typography>
//                         </IconButton>
//                     </div>
//                 </Toolbar>
//             </AppBar>

//             {/* Profile Menu */}
//             <Menu anchorEl={anchorEl} id="profile-menu" open={Boolean(anchorEl)} onClose={handleMenuClose}>
//                 <Link to="/edit_user_profile" style={{ color: "#616771", textDecoration: "none" }}>
//                     <MenuItem onClick={handleMenuClose} className={classes.menuItem}><PersonOutlineOutlined /><span className="ml-2">{user_name}</span></MenuItem>
//                 </Link>
//                 <Link to="/changepassword" style={{ color: "#616771", textDecoration: "none" }}>
//                     <MenuItem onClick={handleMenuClose} className={classes.menuItem}><SettingsOutlined /><span className="ml-2">Change Password</span></MenuItem>
//                 </Link>
//                 <Link to="/login" style={{ color: "#616771", textDecoration: "none" }}>
//                     <MenuItem className={classes.menuItem}><PowerSettingsNewOutlined /><span className="ml-2">Logout</span></MenuItem>
//                 </Link>
//             </Menu>

//             {/* Notifications Menu */}
//             <Menu anchorEl={expired} id="expired-menu" open={Boolean(expired)} onClose={handleExpiredMenuClose}>
//                 <MenuItem component={Link} to="/soon_to_expire" onClick={handleExpiredMenuClose}>
//                     <Badge badgeContent={expiredItems} color="secondary">
//                         <ScheduleOutlinedIcon fontSize="small"/>
//                         <span className="ml-2">Expired Items</span>
//                     </Badge>
//                 </MenuItem>
//                 <MenuItem component={Link} to="/out_of_stock" onClick={handleExpiredMenuClose}>
//                     <Badge badgeContent={outOfStock} color="secondary">
//                         <AddShoppingCartOutlinedIcon fontSize="small"/>
//                         <span className="ml-2">Out Of Stock</span>
//                     </Badge>
//                 </MenuItem>
//                 {approval_status.read && (
//                     <MenuItem component={Link} to="/pendingapproval" onClick={handleExpiredMenuClose}>
//                         <Badge badgeContent={approvalCount} color="secondary">
//                             <ScheduleOutlinedIcon fontSize="small"/>
//                             <span className="ml-2">Approval Status</span>
//                         </Badge>
//                     </MenuItem>
//                 )}
//                 {managependingsale.read && (
//                     <MenuItem component={Link} to="/managependingsale" onClick={handleExpiredMenuClose}>
//                         <Badge badgeContent={pendingCount} color="secondary">
//                             <AddShoppingCartOutlinedIcon fontSize="small"/>
//                             <span className="ml-2">Pending Sales</span>
//                         </Badge>
//                     </MenuItem>
//                 )}
//                 {managependingsale.read && (
//                     <MenuItem component={Link} to="/pendingapproval" onClick={handleExpiredMenuClose}>
//                         <Badge badgeContent={approvedCount} color="secondary">
//                             <ScheduleOutlinedIcon fontSize="small"/>
//                             <span className="ml-2">Approved Sales</span>
//                         </Badge>
//                     </MenuItem>
//                 )}
//             </Menu>

//             {/* Extra Popup with Tabs */}
//             {popupVisible && (
//                 <>
//                     <div className={classes.overlay} onClick={() => setPopupVisible(false)} />
//                     <Paper className={classes.modalWrapper}>
//                         <Typography variant="h6" gutterBottom>Inventory Alert</Typography>
//                         <Tabs value={tabIndex} onChange={(e, val) => setTabIndex(val)} centered>
//                             <Tab label="Soon To Expire" />
//                             <Tab label="Out Of Stock" />
//                         </Tabs>
//                         <div className={classes.tabPanel}>
//                             {tabIndex === 0 && (
//                                 <TableContainer>
//                                     <Table size="small">
//                                         <TableHead>
//                                             <TableRow>
//                                                 <TableCell className={classes.tableHead}>Product Name</TableCell>
//                                                 <TableCell className={classes.tableHead}>Generic Name</TableCell>
//                                                 <TableCell className={classes.tableHead}>Strength</TableCell>
//                                                 <TableCell className={classes.tableHead}>Location</TableCell>
//                                                 <TableCell className={classes.tableHead}>Batch</TableCell>
//                                                 <TableCell className={classes.tableHead}>Stock</TableCell>
//                                                 <TableCell className={classes.tableHead}>Expire Date</TableCell>
//                                             </TableRow>
//                                         </TableHead>
//                                         <TableBody>
//                                             {expiredList.length ? expiredList.map((item, idx) => (
//                                                 <TableRow key={idx}>
//                                                     <TableCell>{item.product_name}</TableCell>
//                                                     <TableCell>{item.generic_name}</TableCell>
//                                                     <TableCell>{item.strength}</TableCell>
//                                                     <TableCell>{item.product_location}</TableCell>
//                                                     <TableCell>{item.batch_number}</TableCell>
//                                                     <TableCell>{item.stock}</TableCell>
//                                                     <TableCell>{item.expdate}</TableCell>
//                                                 </TableRow>
//                                             )) : (
//                                                 <TableRow><TableCell colSpan={7}>No expired products</TableCell></TableRow>
//                                             )}
//                                         </TableBody>
//                                     </Table>
//                                 </TableContainer>
//                             )}
//                             {tabIndex === 1 && (
//                                 <TableContainer>
//                                     <Table size="small">
//                                         <TableHead>
//                                             <TableRow>
//                                                 <TableCell className={classes.tableHead}>Product Name</TableCell>
//                                                 <TableCell className={classes.tableHead}>Generic Name</TableCell>
//                                                 <TableCell className={classes.tableHead}>Strength</TableCell>
//                                                 <TableCell className={classes.tableHead}>Reorder Level</TableCell>
//                                                 <TableCell className={classes.tableHead}>Stock</TableCell>
//                                             </TableRow>
//                                         </TableHead>
//                                         <TableBody>
//                                             {outOfStockList.length ? outOfStockList.map((item, idx) => (
//                                                 <TableRow key={idx}>
//                                                     <TableCell>{item.product_name}</TableCell>
//                                                     <TableCell>{item.generic_name}</TableCell>
//                                                     <TableCell>{item.strength}</TableCell>
//                                                     <TableCell>{item.reorder_level}</TableCell>
//                                                     <TableCell>{item.stock}</TableCell>
//                                                 </TableRow>
//                                             )) : (
//                                                 <TableRow><TableCell colSpan={5}>No out-of-stock products</TableCell></TableRow>
//                                             )}
//                                         </TableBody>
//                                     </Table>
//                                 </TableContainer>
//                             )}
//                         </div>
//                         <Button variant="contained" color="primary" fullWidth onClick={() => setPopupVisible(false)}>Close</Button>
//                     </Paper>
//                 </>
//             )}
//         </ErrorBoundary>
//     );
// }

// function mapStateToProps(state) { return { snackbars: state.snackbars }; }
// function mapDispatchToProps(dispatch) { return { actions: { snackbarActions: bindActionCreators(snackbarActions, dispatch) } }; }

// export default connect(mapStateToProps, mapDispatchToProps)(AppHeader);

import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Badge from '@material-ui/core/Badge';
import NotificationsIcon from '@material-ui/icons/Notifications';
import SettingsIcon from '@material-ui/icons/Settings';
import ScheduleOutlinedIcon from '@material-ui/icons/ScheduleOutlined';
import AddShoppingCartOutlinedIcon from '@material-ui/icons/AddShoppingCartOutlined';
import PersonOutlineOutlined from '@material-ui/icons/PersonOutlineOutlined';
import SettingsOutlined from '@material-ui/icons/SettingsOutlined';
import PowerSettingsNewOutlined from '@material-ui/icons/PowerSettingsNewOutlined';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import Brightness7Icon from '@material-ui/icons/Brightness7';
import MenuIcon from '@material-ui/icons/Menu';
import { Link } from "react-router-dom";
import axios from "axios";
import config from "../Helpers/config.json";
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import * as snackbarActions from "../Redux/Actions/SnackbarActions/SnackbarActions";
import { BootstrapTooltip } from "../Utils/BootstrapTooltip";
import { Modal, Paper, Typography, Tabs, Tab, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Button } from "@material-ui/core";

// 🔹 Error Boundary
class ErrorBoundary extends React.Component {
    constructor(props) { super(props); this.state = { hasError: false }; }
    static getDerivedStateFromError() { return { hasError: true }; }
    componentDidCatch(error, errorInfo) { console.error("Error in AppHeader:", error, errorInfo); }
    render() {
        if (this.state.hasError) {
            return (
                <AppBar style={{ backgroundColor: '#b71c1c' }}>
                    <Toolbar variant="dense">
                        <span style={{ color: "#fff" }}>Something went wrong loading the header.</span>
                    </Toolbar>
                </AppBar>
            );
        }
        return this.props.children;
    }
}

// 🔹 Styles
const useStyles = makeStyles((theme) => ({
    grow: { flexGrow: 1 },
    sectionDesktop: { display: 'flex', alignItems: 'center', gap: theme.spacing(1) },
    menuItem: { minHeight: 40 },
    modalWrapper: {
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: theme.spacing(2),
        maxWidth: 1000,
        width: "90%",
        zIndex: 1500,
        maxHeight: "80vh",
        overflowY: "auto",
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.3)",
        zIndex: 1400,
    },
    tableHead: { fontWeight: 'bold', fontSize: '0.85rem' },
    tabPanel: { paddingTop: theme.spacing(1) },
    anniversaryAppBar: {
        background: 'linear-gradient(270deg, #ff4081, #ffeb3b, #1fa7b0)',
        backgroundSize: '600% 600%',
        animation: '$gradientAnimation 20s ease infinite',
    },
    '@keyframes gradientAnimation': {
        '0%': { backgroundPosition: '0% 50%' },
        '50%': { backgroundPosition: '100% 50%' },
        '100%': { backgroundPosition: '0% 50%' },
    },
    '@keyframes glow': {
        from: { textShadow: '0 0 8px #ff4081' },
        to: { textShadow: '0 0 16px #ffeb3b, 0 0 24px #1fa7b0' },
    },
    anniversaryText: {
        color: '#fff',
        fontWeight: 'bold',
        fontSize: '0.95rem',
        textAlign: 'center',
        width: '100%',
        flexGrow: 1,
        animation: '$glow 2s ease-in-out infinite alternate',
        textShadow: '0 0 8px #ff4081, 0 0 16px #ffeb3b, 0 0 24px #1fa7b0',
        padding: '4px 0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}));

function AppHeader({
    actions,
    children,
    darkMode = false,
    onToggleDarkMode,
    onToggleDrawer,
    drawerOpen = true,
    ...props
}) {
    const classes = useStyles();
    const [showBanner, setShowBanner] = useState(true);

    const [anchorEl, setAnchorEl] = useState(null);
    const [expired, setExpired] = useState(null);
    const [expiredItems, setExpiredItems] = useState(0);
    const [outOfStock, setOutOfStock] = useState(0);
    const [approvalCount, setApprovalCount] = useState(0);
    const [pendingCount, setPendingCount] = useState(0);
    const [approvedCount, setApprovedCount] = useState(0);

    const [popupVisible, setPopupVisible] = useState(false);
    const [tabIndex, setTabIndex] = useState(0);
    const [expiredList, setExpiredList] = useState([]);
    const [outOfStockList, setOutOfStockList] = useState([]);

    const prevCounts = useRef({ approval: 0, pending: 0, approved: 0 });
    const alertAudio = useRef(null);
    const approvedSaleAudio = useRef(null);

    const user = JSON.parse(sessionStorage.getItem("user")) || {};
    const permissions = user?.permission || {};
    const user_name = user?.user_name || "";
    const approval_status = permissions.approval_status || {};
    const managependingsale = permissions.managependingsale || {};

    const POLL_INTERVAL = 9000; 
    const SESSION_KEY = "popupShown";

    const playAlert = () => {
        if (!alertAudio.current) alertAudio.current = new Audio('/audio/happy-bells-notification.mp3');
        alertAudio.current.play().catch(e => console.warn("Audio blocked:", e.message));
    };
    const playAlertApprovedSale = () => {
        if (!approvedSaleAudio.current) approvedSaleAudio.current = new Audio('/audio/great-success.mp3');
        approvedSaleAudio.current.play().catch(e => console.warn("Audio blocked:", e.message));
    };

    useEffect(() => {
        import('canvas-confetti').then((confetti) => {
          confetti.default({ particleCount: 200, spread: 80, origin: { y: 0.6 } });
        });
    }, []);

    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();

        const fetchStaticCounts = async () => {
            try {
                const [expiredRes, stockRes] = await Promise.all([
                    axios.get(`${config.epharmUrl}/User/expired_products`, { signal: controller.signal }),
                    axios.get(`${config.epharmUrl}/User/out_of_stock`, { signal: controller.signal })
                ]);
                if (!isMounted) return;

                const expiredCount = expiredRes.data?.expired_products?.length || 0;
                const stockCount = stockRes.data?.length || 0;

                setExpiredItems(expiredCount);
                setOutOfStock(stockCount);
                setExpiredList(expiredRes.data?.expired_products || []);
                setOutOfStockList(stockRes.data || []);

                if (!sessionStorage.getItem(SESSION_KEY) && (expiredCount > 0 || stockCount > 0)) {
                    setPopupVisible(true);
                    sessionStorage.setItem(SESSION_KEY, "true");
                }
            } catch (err) {
                if (err.name !== "CanceledError") console.error("Error fetching static counts:", err.message || err);
            }
        };

        const fetchDynamicCounts = async () => {
            try {
                if (!isMounted) return;
                if (approval_status.create) {
                    const res = await axios.get(`${config.epharmUrl}/Cinvoice/count/pending_sales`, { signal: controller.signal });
                    const count = res.data?.count || 0;
                    setApprovalCount(count);
                    if (count > prevCounts.current.approval) playAlert();
                    prevCounts.current.approval = count;
                }
                if (managependingsale.create) {
                    const res = await axios.get(`${config.epharmUrl}/Cinvoice/count/pending_sales`, { signal: controller.signal });
                    const count = res.data?.count || 0;
                    setPendingCount(count);
                    if (count > prevCounts.current.pending) playAlert();
                    prevCounts.current.pending = count;
                }
                if (approval_status.read) {
                    const approvedRes = await axios.get(`${config.epharmUrl}/Cinvoice/count/approved_sales`, { signal: controller.signal });
                    const count = approvedRes.data?.count || 0;
                    setApprovedCount(count);
                    if (count > prevCounts.current.approved) playAlertApprovedSale();
                    prevCounts.current.approved = count;
                }
            } catch (err) {
                if (err.name !== "CanceledError") console.error("Error fetching dynamic counts:", err.message || err);
            }
        };

        fetchStaticCounts();
        fetchDynamicCounts();
        const interval = setInterval(fetchDynamicCounts, POLL_INTERVAL);

        return () => { isMounted = false; controller.abort(); clearInterval(interval); };
    }, [approval_status.read, managependingsale.read]);

    const handleProfileMenuOpen = e => setAnchorEl(e.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);
    const handleExpiredMenuOpen = e => setExpired(e.currentTarget);
    const handleExpiredMenuClose = () => setExpired(null);

    return (
        <ErrorBoundary>
            <AppBar
                color="primary"
                style={{
                    backgroundColor: darkMode ? '#1a2332' : '#1fa7b0',
                    boxShadow: darkMode ? '0 1px 6px rgba(0,0,0,0.45)' : '0 1px 4px rgba(0,0,0,0.12)',
                    transition: 'background-color 0.25s ease',
                }}
                {...props}
            >
                <Toolbar variant="dense" style={{ minHeight: 52 }}>
                    {/* Hamburger / menu toggle on AppBar */}
                    {typeof onToggleDrawer === 'function' && (
                        <BootstrapTooltip title={drawerOpen ? 'Collapse sidebar' : 'Expand sidebar'}>
                            <IconButton
                                color="inherit"
                                edge="start"
                                onClick={onToggleDrawer}
                                size="small"
                                style={{ marginRight: 8 }}
                            >
                                <MenuIcon fontSize="small" />
                            </IconButton>
                        </BootstrapTooltip>
                    )}

                    <div>{children}</div>

                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                        {showBanner && (
                            <Typography variant="subtitle1" className={classes.anniversaryText} />
                        )}
                    </div>

                    <div className={classes.grow} />

                    <div className={classes.sectionDesktop}>
                        {/* Dark mode toggle on AppBar */}
                        {typeof onToggleDarkMode === 'function' && (
                            <BootstrapTooltip title={darkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
                                <IconButton
                                    color="inherit"
                                    onClick={onToggleDarkMode}
                                    size="small"
                                >
                                    {darkMode ? (
                                        <Brightness7Icon fontSize="small" />
                                    ) : (
                                        <Brightness4Icon fontSize="small" />
                                    )}
                                </IconButton>
                            </BootstrapTooltip>
                        )}

                        <BootstrapTooltip title="Notifications">
                            <IconButton aria-controls="expired-menu" onClick={handleExpiredMenuOpen} color="inherit" size="small">
                                <Badge badgeContent={expiredItems + outOfStock + approvalCount + pendingCount + approvedCount} color="secondary">
                                    <NotificationsIcon fontSize="small" />
                                </Badge>
                            </IconButton>
                        </BootstrapTooltip>

                        <IconButton edge="end" aria-controls="profile-menu" onClick={handleProfileMenuOpen} color="inherit" size="small">
                            <SettingsIcon fontSize="small" />
                        </IconButton>

                        <IconButton
                            edge="end"
                            aria-controls="profile-menu"
                            aria-haspopup="true"
                            onClick={handleProfileMenuOpen}
                            color="inherit"
                            size="small"
                            style={{ display: 'flex', alignItems: 'center', gap: 4 }}
                        >
                            <PersonOutlineOutlined fontSize="small" />
                            <Typography variant="body2" noWrap>{user_name}</Typography>
                        </IconButton>
                    </div>
                </Toolbar>
            </AppBar>

            {/* Profile Menu */}
            <Menu anchorEl={anchorEl} id="profile-menu" open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <Link to="/edit_user_profile" style={{ color: "#616771", textDecoration: "none" }}>
                    <MenuItem onClick={handleMenuClose} className={classes.menuItem}><PersonOutlineOutlined /><span className="ml-2">{user_name}</span></MenuItem>
                </Link>
                <Link to="/changepassword" style={{ color: "#616771", textDecoration: "none" }}>
                    <MenuItem onClick={handleMenuClose} className={classes.menuItem}><SettingsOutlined /><span className="ml-2">Change Password</span></MenuItem>
                </Link>
                <Link to="/login" style={{ color: "#616771", textDecoration: "none" }}>
                    <MenuItem className={classes.menuItem}><PowerSettingsNewOutlined /><span className="ml-2">Logout</span></MenuItem>
                </Link>
            </Menu>

            {/* Notifications Menu */}
            <Menu anchorEl={expired} id="expired-menu" open={Boolean(expired)} onClose={handleExpiredMenuClose}>
                <MenuItem component={Link} to="/soon_to_expire" onClick={handleExpiredMenuClose}>
                    <Badge badgeContent={expiredItems} color="secondary">
                        <ScheduleOutlinedIcon fontSize="small"/>
                        <span className="ml-2">Expired Items</span>
                    </Badge>
                </MenuItem>
                <MenuItem component={Link} to="/out_of_stock" onClick={handleExpiredMenuClose}>
                    <Badge badgeContent={outOfStock} color="secondary">
                        <AddShoppingCartOutlinedIcon fontSize="small"/>
                        <span className="ml-2">Out Of Stock</span>
                    </Badge>
                </MenuItem>
                {approval_status.read && (
                    <MenuItem component={Link} to="/pendingapproval" onClick={handleExpiredMenuClose}>
                        <Badge badgeContent={approvalCount} color="secondary">
                            <ScheduleOutlinedIcon fontSize="small"/>
                            <span className="ml-2">Approval Status</span>
                        </Badge>
                    </MenuItem>
                )}
                {managependingsale.read && (
                    <MenuItem component={Link} to="/managependingsale" onClick={handleExpiredMenuClose}>
                        <Badge badgeContent={pendingCount} color="secondary">
                            <AddShoppingCartOutlinedIcon fontSize="small"/>
                            <span className="ml-2">Pending Sales</span>
                        </Badge>
                    </MenuItem>
                )}
                {managependingsale.read && (
                    <MenuItem component={Link} to="/pendingapproval" onClick={handleExpiredMenuClose}>
                        <Badge badgeContent={approvedCount} color="secondary">
                            <ScheduleOutlinedIcon fontSize="small"/>
                            <span className="ml-2">Approved Sales</span>
                        </Badge>
                    </MenuItem>
                )}
            </Menu>

            {/* Extra Popup with Tabs */}
            {popupVisible && (
                <>
                    <div className={classes.overlay} onClick={() => setPopupVisible(false)} />
                    <Paper className={classes.modalWrapper}>
                        <Typography variant="h6" gutterBottom>Inventory Alert</Typography>
                        <Tabs value={tabIndex} onChange={(e, val) => setTabIndex(val)} centered>
                            <Tab label="Soon To Expire" />
                            <Tab label="Out Of Stock" />
                        </Tabs>
                        <div className={classes.tabPanel}>
                            {tabIndex === 0 && (
                                <TableContainer>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className={classes.tableHead}>Product Name</TableCell>
                                                <TableCell className={classes.tableHead}>Generic Name</TableCell>
                                                <TableCell className={classes.tableHead}>Strength</TableCell>
                                                <TableCell className={classes.tableHead}>Location</TableCell>
                                                <TableCell className={classes.tableHead}>Batch</TableCell>
                                                <TableCell className={classes.tableHead}>Stock</TableCell>
                                                <TableCell className={classes.tableHead}>Expire Date</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {expiredList.length ? expiredList.map((item, idx) => (
                                                <TableRow key={idx}>
                                                    <TableCell>{item.product_name}</TableCell>
                                                    <TableCell>{item.generic_name}</TableCell>
                                                    <TableCell>{item.strength}</TableCell>
                                                    <TableCell>{item.product_location}</TableCell>
                                                    <TableCell>{item.batch_number}</TableCell>
                                                    <TableCell>{item.stock}</TableCell>
                                                    <TableCell>{item.expdate}</TableCell>
                                                </TableRow>
                                            )) : (
                                                <TableRow><TableCell colSpan={7}>No expired products</TableCell></TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            )}
                            {tabIndex === 1 && (
                                <TableContainer>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className={classes.tableHead}>Product Name</TableCell>
                                                <TableCell className={classes.tableHead}>Generic Name</TableCell>
                                                <TableCell className={classes.tableHead}>Strength</TableCell>
                                                <TableCell className={classes.tableHead}>Reorder Level</TableCell>
                                                <TableCell className={classes.tableHead}>Stock</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {outOfStockList.length ? outOfStockList.map((item, idx) => (
                                                <TableRow key={idx}>
                                                    <TableCell>{item.product_name}</TableCell>
                                                    <TableCell>{item.generic_name}</TableCell>
                                                    <TableCell>{item.strength}</TableCell>
                                                    <TableCell>{item.reorder_level}</TableCell>
                                                    <TableCell>{item.stock}</TableCell>
                                                </TableRow>
                                            )) : (
                                                <TableRow><TableCell colSpan={5}>No out-of-stock products</TableCell></TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            )}
                        </div>
                        <Button variant="contained" color="primary" fullWidth onClick={() => setPopupVisible(false)}>Close</Button>
                    </Paper>
                </>
            )}
        </ErrorBoundary>
    );
}

function mapStateToProps(state) { return { snackbars: state.snackbars }; }
function mapDispatchToProps(dispatch) { return { actions: { snackbarActions: bindActionCreators(snackbarActions, dispatch) } }; }

export default connect(mapStateToProps, mapDispatchToProps)(AppHeader);